export default __webpack_public_path__ + "static/carousel-10-ed799f9a5bdc70b14c539f9fbe9f22f0.jpg";